// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO: https://lucidlink.atlassian.net/browse/LUCID-18777 */
/* stylelint-disable-next-line selector-max-specificity -- fix gap when input has IconButton next to it and input has validation rules */
.DatePickerField-module__Container__W3eiK:has(ul:empty) {
    gap: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `DatePickerField-module__Container__W3eiK`
};
export default ___CSS_LOADER_EXPORT___;
